import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TimeoutModalService } from '../../spartacus/services/timeout-modal.service';
import { BaseSiteService, CmsService } from '@spartacus/core';

@Component({
    selector: 'app-timeout-modal',
    templateUrl: './timeout-modal.component.html',
    styleUrls: ['./timeout-modal.component.scss'],
    standalone: false
})
export class TimeoutModalComponent implements OnInit, OnDestroy{

  private destroy$ = new Subject<void>();
  showModal = false;
  minutes = 5;
  seconds = 0;
  private countdownInterval: any;
  currentSite: string = '';
  jobBagCode: string = '';

  constructor(private baseSiteService: BaseSiteService, private timeoutModalService: TimeoutModalService, private cdr: ChangeDetectorRef,private cmsService:CmsService) {;
  }

  ngOnInit(): void {

    this.baseSiteService.getActive().pipe(
      takeUntil(this.destroy$)
    ).subscribe(site => {
      this.currentSite = site;
    });
     this.cmsService.getComponentData<any>('timeoutjobbag')
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.jobBagCode = data?.jobBagCode ?? '';
        this.cdr.detectChanges();
      });

    this.timeoutModalService.showModal$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(show => {
      this.showModal = show;
      if (show) {
        this.startCountdown();
      } else {
        this.stopCountdown();
      }
      this.cdr.detectChanges();
    });

    this.timeoutModalService.initialize();
  }

  private startCountdown(): void {
    this.minutes = 5;
    this.seconds = 0;
    this.countdownInterval = setInterval(() => {
      if (this.seconds === 0) {
        if (this.minutes === 0) {
          this.stopCountdown();
          this.cdr.detectChanges();
          return;
        }
        this.minutes--;
        this.seconds = 59;
      } else {
        this.seconds--;
      }
      this.cdr.detectChanges();
    }, 1000);
  }

  private stopCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  resetSession(): void {
    this.timeoutModalService.resetSession();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.stopCountdown();
  }

}
